'use client';

import Image from "next/image";

type OrangeVisionSectionProps = {
  mainQuote: string;
  add_background?: boolean;
};

export function OrangeVisionSection({ mainQuote, add_background = false }: OrangeVisionSectionProps) {
  const content = (
    <div className="relative w-full">
      <Image
        src="/images/illustration/quotes.png"
        alt="Vision background"
        width={1200}
        height={600}
        className="w-full h-auto"
        priority
      />
      <h5 className="text-white text-xs md:text-2xl font-bold absolute inset-0 flex items-center justify-center text-center p-2 md:px-24">
        {mainQuote}
      </h5>
    </div>
  );

  if (add_background) {
    return (
      <section className="w-screen relative left-1/2 right-1/2 -mx-[50vw] bg-gradient-to-b from-[rgba(237,237,249,0)] to-[#DEE5E8] my-8 py-8">
        <div className="bg-[url('/images/left-corner-supergrafis.png')] bg-no-repeat bg-left-bottom bg-[length:300px]">
          <div className="container max-w-7xl mx-auto items-start gap-8 flex">
            <div className="flex-1 min-w-0 px-10">
              {content}
            </div>
            <div className="w-80 flex-shrink-0 lg:block"></div>
          </div>
        </div>
      </section>
    );
  }

  return (
    <div className="container mx-auto max-w-7xl px-10">
      {content}
    </div>
  );
}
